export const QUESTION_QUERY_MIN_LENGTH = 2;
export const TOPICS_DROPDOWN_SELECTOR_MIN = 5;
